import React from 'react';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Styles from './BancoAutoMotoDesktop.css';
import WhiteButton from '@/components/atoms/WhiteButton';

function BancoAutoMotoDesktop() {
  return (
    <section id="banco-do-auto-moto" className="desktop">
      <ContainerHome24 className="container-moto">
        <img
          className="banco-do-auto-imagem"
          src="assets/banco-do-auto25/moto-escudo.svg"
          alt="ilustração moto"
        />
        <div>
          <h3 className="moto-title">
            Seguro avulso para seu veículo <b>novo e usado</b>
          </h3>
          <p className="moto-paragrafo">
            {' '}
            <p className="moto-paragrafo">
              Saiba mais informações sobre como funciona o nosso seguro para motos. Disponibilizamos
              abaixo o regulamento da campanha Moto segura (seguro para terceiros).
            </p>
          </p>
          <a
            className="link-regulamento"
            href="pdf/seguro-moto/regulamento_moto_segura.pdf"
            target="_blank"
          >
            <img src="assets/banco-do-auto25/icon-baixar.svg" alt="Icone Baixar Regulamento" />
            Confira o Regulamento
          </a>

          <WhiteButton
            className="link-banco-do-auto-moto"
            href="seguro-santander-auto.html"
            target="_blank"
          >
            Consultar
          </WhiteButton>
        </div>
        <style jsx>{Styles}</style>
      </ContainerHome24>
    </section>
  );
}

export default BancoAutoMotoDesktop;
